import React, { useRef } from 'react'
import { DatePicker } from 'rsuite'
import { format, isValid } from 'date-fns'
import { FormikInputs } from './interfaces'

function DateInput<V>(props: Readonly<FormikInputs<V>>): React.ReactElement {
  const { formik, name, isDisabled, placeholder } = props
  const dateValue = (formik?.values as Record<string, any>)[name]
  const containerRef = useRef<HTMLDivElement>(null)

  const handleDateChange = (val: Date | null) => {
    const formattedDate = val && isValid(val) ? format(val, 'yyyy-MM-dd') : ''
    formik?.setFieldValue(name, formattedDate)
  }

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <DatePicker
        format="MM/dd/yyyy"
        value={
          dateValue && isValid(new Date(dateValue)) ? new Date(dateValue) : null
        }
        onChange={handleDateChange}
        oneTap
        block
        disabled={isDisabled}
        container={() => containerRef.current as HTMLElement}
        placeholder={placeholder}
      />
    </div>
  )
}

export default DateInput
